<template>
	<section class="kr-sub-header-layout">
		<main class="kr-sub-header-layout__main">
			<div class="kr-sub-header-layout__stack end-date-stack">
				<slot name="end-date"></slot>
			</div>
			<div class="kr-sub-header-layout__stack last-updated-stack">
				<slot name="last-updated"></slot>
			</div>
			<div class="kr-sub-header-layout__stack confidence-stack">
				<slot name="confidence-level"></slot>
			</div>
			<div class="kr-sub-header-layout__stack progress-stack">
				<slot name="progress"></slot>
			</div>
			<div class="kr-sub-header-layout__stack current-stack">
				<slot name="current"></slot>
			</div>
			<div class="kr-sub-header-layout__stack target-stack">
				<slot name="target"></slot>
			</div>
		</main>
	</section>
</template>

<script>
export default {
	name: "KRSubHeaderLayout",
};
</script>

<style lang="scss" scoped>
$krSubHeaderLayoutBorderColor: $color1-200;

.kr-sub-header-layout {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 0.6rem;

	padding: 1rem;

	@include for-size('md') {
		border-bottom: 0.0625rem solid $krSubHeaderLayoutBorderColor;
		padding: 0 1rem 2rem 1rem;
	}
}

.kr-sub-header-layout__main {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 2rem;

	:nth-child(4) {
		flex: 1;
	}
}

.kr-sub-header-layout__stack {
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	gap: 0.4rem;
}

.kr-sub-header-layout__stack.current-stack,
.kr-sub-header-layout__stack.target-stack,
.kr-sub-header-layout__stack.last-updated-stack {
	display: none;

	@include for-size('md') {
		display: flex;
	}
}
</style>
